// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"38318":"d92f4ca12db8928e","63520":"85c384c1c623e9b6","72853":"5215cf682ef66b83","84736":"58850352c2ee37c2"}[chunkId] + ".css";
};